import { makeStyles } from '@material-ui/core';

type StylesProps = {
  clickable: boolean;
};

export default makeStyles(theme => ({
  container: {
    // @ts-ignore
    border: `1px solid ${theme.palette.secondary[100]}`,
    borderRadius: 8,
    background: theme.palette.common.white,
    boxShadow: '0 10px 26px rgba(16, 24, 40, 0.06)',
    padding: theme.spacing(2),
    cursor: ({ clickable }: StylesProps) => (clickable ? 'pointer' : 'auto'),
    transition: theme.transitions.create(['transform', 'box-shadow'], {
      duration: theme.transitions.duration.shorter,
    }),
    '@media (hover: hover)': {
      '&:hover': {
        transform: ({ clickable }: StylesProps) => (clickable ? 'translateY(-2px)' : 'none'),
        boxShadow: ({ clickable }: StylesProps) => (clickable ? '0 14px 30px rgba(16, 24, 40, 0.1)' : '0 10px 26px rgba(16, 24, 40, 0.06)'),
      },
    },
  },
}));
